<div class="main" *ngIf="address">
  <div class="row address-container heading-text">
    <div class="col-md-4 space-top">
      <label>{{ "quoteTracking.soldTo" | cxTranslate }}</label>
    </div>
    <div class="col-md-4 space-top">
      <label>{{ "quoteTracking.shipTo" | cxTranslate }}</label>
    </div>
    <div class="col-md-4 space-top">
      <label>{{ "quoteTracking.endCustomerAddress" | cxTranslate }}</label>
    </div>
  </div>

  <div class="row address-container">
    <div class="col-md-4">
      <div>
        <address>
          <div class="name">{{ address?.quoteCreatedBy }}</div>
          <div>{{ soldToAdd[0] }}</div>
          <div>{{ soldToAdd[2] }}</div>
          <div>{{ soldToAdd[3] }} {{ soldToAdd[4] }} {{ soldToAdd[5] }}</div>
          <div>{{ soldToAdd[6] }} {{ soldToAdd[7] }}</div>
        </address>
      </div>
    </div>
    <div class="col-md-4">
      <div class="align-right">
        <address>
          <div class="name">{{ address?.quoteCreatedBy }}</div>
          <div>{{ shipToAdd[1] }}</div>
          <div>{{ shipToAdd[3] }}</div>
          <div>{{ shipToAdd[4] }} {{ shipToAdd[5] }} {{ shipToAdd[6] }}</div>
          <div>{{ shipToAdd[7] }} {{ shipToAdd[8] }}</div>
        </address>
      </div>
    </div>
    <div class="col-md-4">
      <div>
        <address>
          <div class="name">{{ address?.quoteCreatedBy }}</div>
          <div>{{ endAdd[1] }}</div>
          <div>{{ endAdd[3] }}</div>
          <div>{{ endAdd[4] }} {{ endAdd[5] }} {{ endAdd[6] }}</div>
          <div>{{ endAdd[7] }} {{ endAdd[8] }}</div>
        </address>
      </div>
    </div>
  </div>
</div>
